// extracted by mini-css-extract-plugin
module.exports = {"productCarousel":"wj","itemsContainer":"xj"};